<template>
    <div class="page">
        <div class="button-container">
            <div class="button" @click="openPath">打开安居客APP</div>
        </div>
        <div v-show="openTipsVisible" class="ios-wx-open-tips" @click="openTipsVisible = false">
            <div class="ios-wx-open-tips-content">
                <img src="https://pages.anjukestatic.com/fe/esf/img/19f05710/comm_login_img_yindao@3x.png" />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
html {
    width: 100%;
    height: 100%;
}
.button-container {
    width: 100vw;
    height: 100vh;
    background: url('//pages.anjukestatic.com/fe/esf/img/842ad42c/anjuke@2x.png') no-repeat top left/contain;
    position: relative;
}

.button {
    position: absolute;
    width: calc(100% - 40px);
    bottom: 96px;
    background: #00cc90;
    border-radius: 3px;
    line-height: 44px;
    height: 44px;
    text-align: center;
    margin: 0 20px;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
}
.ios-wx-open-tips {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 99;
}
.ios-wx-open-tips-content {
    position: absolute;
    z-index: 10;
    top: 16px;
    right: 0;
    width: 300px;
}
.ios-wx-open-tips-content > img {
    width: 300px;
}
</style>

<script>
const iosOpen = 'openanjuke://app.anjuke.com/m/app/share_webview?page_url=';
const androidOpen = 'openanjuke://app.anjuke.com/app_tw_page?twurl=';
import { isWX, checkOpenAppByBroswer, getIOSVersion, checkOpenAppByBroswerInIos } from './helper';

export default {
    head() {
        return {
            title: '安居客',
            meta: [
                { name: 'apple-mobile-web-app-capable', content: 'yes' },
                { name: 'apple-touch-fullscreen', content: 'yes' },
                { name: 'applicable-device', content: 'mobile' }
            ]
        };
    },
    data() {
        return {
            isIos: false,
            isAndroid: false,
            isWx: false,
            openTipsVisible: false,
            jumpTarget: '',
            pm: '',
            from: ''
        };
    },
    inject: ['APP'],
    beforeMount() {
        this.pm = this.$route.query.pm || 'b1062';
        this.from = this.$route.query.from;
        let ua = navigator.userAgent;
        this.isIos = /iPhone|iPad|iPod|iOS/gi.test(ua);
        this.isAndroid = /Android/gi.test(ua);
        let target = this.$route.query.jump_target;

        if (!/^(openanjuke:\/\/)/.test(target) && /^openanjuke/.test(target)) {
            this.jumpTarget = decodeURIComponent(target || '');
        } else {
            this.jumpTarget = target || '';
        }
        this.isAppProtocol = /^(openanjuke:\/\/)/.test(this.jumpTarget);
        if (/^http(s)?:\/\//.test(this.jumpTarget)) {
            let url = this.jumpTarget.replace(/^http(s)?:\/\//, '');
            let host = url.split('/');
            this.isH5Protocol = /^([a-zA-Z0-9\-](\.)?)+(\.anjuke\.(com|test))$/.test(host[0]);
        } else {
            this.isH5Protocol = false;
        }
        this.$soj.sendPv('Anjuke_DownApp', {
            from: this.from,
            target: this.jumpTarget,
            show: 'm_wake_app_show'
        });
        // 微信不唤端
        if (isWX(ua)) return false;
        // 此处的app 的协议只针对H5转APP的协议,需要过滤掉RN的协议
        const newIumpTarget = decodeURIComponent(decodeURIComponent(decodeURIComponent(this.jumpTarget)))
        if (this.isAppProtocol && newIumpTarget.indexOf('openanjuke://jump/RN/RN') !== 0) {
            let url = this.jumpTarget;
            // if (checkOpenAppByBroswerInIos()) {
            //     url = 'openanjuke://app.anjuke.com/home';
            // }
            this.$driver.openApp({
                href: url,
                timeout: 3000,
                android: {
                    pm: this.pm,
                    version: '11.8.2'
                }
            });
            return false;
        }

        if (this.isH5Protocol) {
            this.$driver.openApp({
                href: this.jumpTarget,
                timeout: 3000,
                android: {
                    pm: this.pm,
                    version: '11.8.2'
                }
            });
            return false;
        }
        this.$driver.openApp({
            href: this.jumpTarget,
            timeout: 3000,
            android: {
                pm: this.pm,
                version: '11.8.2'
            }
        });
    },
    methods: {
        openPath() {
            this.$soj.trackEvent('Anjuke_DownApp_click', {
                from: this.from,
                target: this.jumpTarget,
                show: 'm_wake_app_show'
            });
            if (!this.isAppProtocol && !this.isH5Protocol) {
                this.$driver.openApp({
                    href: 'openanjuke://app.anjuke.com/home',
                    android: {
                        pm: this.pm,
                        version: '11.8.2'
                    }
                });
                return false;
            }
            if ((this.isH5Protocol || this.isAppProtocol) && checkOpenAppByBroswer()) {
                this.openTipsVisible = true;
                return false;
            }
            if (this.isAppProtocol || this.isH5Protocol || isWX(navigator.userAgent)) {
                let URL = this.jumpTarget;
                if (getIOSVersion(navigator.userAgent) && !this.isH5Protocol && this.jumpTarget.includes('m.anjuke.')) {
                    URL = 'openanjuke://app.anjuke.com/home';
                }
                this.$driver.openApp({
                    href: URL,
                    android: {
                        pm: this.pm,
                        version: '11.8.2'
                    }
                });
                return false;
            }
            this.$driver.openApp({
                href: this.jumpTarget,
                android: {
                    pm: this.pm,
                    version: '11.8.2'
                }
            });
        }
    }
};
</script>
